export default "__VITE_ASSET__8faf2c71__"